/**
 * storageHelper.js — Storage Validation & Initialization
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. validateStorage returns a clear boolean
 *  2. clearCorruptedStorage checks the actual persist key used by the app
 *  3. Added LAUNCH_STORE_NAME check alongside persist:root
 */

import { LAUNCH_STORE_NAME } from './constants';

/**
 * Test that localStorage is available and writable.
 * @returns {boolean}
 */
export const validateStorage = () => {
  try {
    const testKey = '__storage_test__';
    localStorage.setItem(testKey, 'test');
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.error('localStorage is not available or corrupted:', e);
    return false;
  }
};

/**
 * Detect and clear corrupted storage entries.
 * Checks both Redux persist key and the app's launch store.
 */
export const clearCorruptedStorage = () => {
  const keysToCheck = ['persist:root', LAUNCH_STORE_NAME];

  keysToCheck.forEach((key) => {
    try {
      const value = localStorage.getItem(key);
      if (value) {
        JSON.parse(value); // Will throw if corrupted
      }
    } catch (e) {
      console.warn(`Corrupted storage detected for "${key}", clearing...`);
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    }
  });
};

/**
 * Run on app start. Returns false if storage is unavailable.
 * @returns {boolean}
 */
export const initializeStorage = () => {
  if (!validateStorage()) {
    console.warn('Storage not available, clearing and reloading...');
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      // Nothing more we can do
    }
    return false;
  }

  clearCorruptedStorage();
  return true;
};
